
import { MapLocation } from '@/types/location';

export const abhaDigitalMegacomScreens: MapLocation[] = [
  {
    id: 10035,
    name: "Digital Megacom Screen – Abha",
    type: "Digital Megacom",
    devices: 2,
    coordinates: [18.240389, 42.579583], // Converted from 18°14'23.0"N 42°34'47.7"E
    region: "Abha",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 2 faces\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/fecc6238-a0d0-4ec8-9b2d-324c7ff62a70.png"
    }
  },
  {
    id: 10036,
    name: "Digital Megacom Screen – Abha 2",
    type: "Digital Megacom",
    devices: 2,
    coordinates: [18.2417778, 42.601], // Converted from 18°14'30.4"N 42°36'03.6"E
    region: "Abha",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 2 faces\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/dea4876a-4c76-48d2-8e3b-19431a99ae1d.png"
    }
  },
  {
    id: 10037,
    name: "Digital Megacom Screen – Abha 3",
    type: "Digital Megacom",
    devices: 2,
    coordinates: [18.2180806, 42.5147639], // Converted from 18°13'04.9"N 42°30'53.1"E
    region: "Abha",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 2 faces\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/a0a2e8d2-967f-42c7-ad5f-245430c962bf.png"
    }
  },
  {
    id: 10038,
    name: "Digital Megacom Screen – Abha 4",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [18.243522222, 42.637222222], // Converted from 18°14'36.8"N 42°38'13.6"E
    region: "Abha",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/2b74b3aa-9896-4f50-be5d-d9c2ab68263e.png"
    }
  },
  {
    id: 10039,
    name: "Digital Megacom Screen – Abha 5",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [18.2192667, 42.5219722], // Converted from 18°13'09.6"N 42°31'19.1"E
    region: "Abha",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/f10d0e9d-bc56-4b24-b101-ddcf30c7f215.png"
    }
  },
  {
    id: 10040,
    name: "Digital Megacom Screen – Abha 6",
    type: "Digital Megacom",
    devices: 2,
    coordinates: [18.2390167, 42.5803056], // Converted from 18°14'20.6"N 42°34'49.0"E
    region: "Abha",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 2 faces\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/4ed9e3a2-53c5-4b63-bb2e-f88305a624f0.png"
    }
  },
  {
    id: 10041,
    name: "Digital Megacom Screen – Abha 7",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [18.2186833, 42.5239167], // Converted from 18°13'07.1"N 42°31'26.1"E
    region: "Abha",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/344116b6-86a6-4d08-8323-57a8d50fe9cf.png"
    }
  },
  {
    id: 10042,
    name: "Digital Megacom Screen – Abha 8",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [18.2393333, 42.6434722], // Converted from 18°14'21.6"N 42°38'36.5"E
    region: "Abha",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/6bd5d995-98da-4d5b-82b5-179ca0b366c6.png"
    }
  },
  {
    id: 10043,
    name: "Digital Megacom Screen – Abha 9",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [18.2395444, 42.6440444], // Converted from 18°14'21.6"N 42°38'41.6"E
    region: "Abha",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/662f4b19-c41d-4bc1-a9a5-ea92822f15d9.png"
    }
  }
];